import React, { useMemo } from "react";
import { flexRender, getCoreRowModel, useReactTable } from "@tanstack/react-table";
import "./processingSummaryTable.scss";

const ProcessingSummaryTableForCoa = ({ data, columns, openDetailsPopUp, type }) => {
  const memoData = useMemo(() => data, [type, data]);
  const memoCols = useMemo(() => columns, [type, columns]);

  const table = useReactTable({
    data: memoData,
    columns: memoCols,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="processing-summary-table-container">
      <table className="table">
        <thead className="thead">
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header, idx) => {
                const isFirst = idx === 0;
                const style = {
                  fontSize: "13px",
                  fontWeight: "normal",
                  paddingLeft: isFirst ? "10px" : "0px",
                  textAlign: isFirst ? "left" : "center",
                  backgroundColor: "white",
                  color: "black",
                };
                return (
                  <th key={header.id} style={style}>
                    <p style={{ padding: "10px 0" }}>
                      {flexRender(header.column.columnDef.header, header.getContext())}
                    </p>
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>

        <tbody className="tbody">
          {table.getRowModel().rows.map((row, rowIdx) => {
            const rowStyle = {
              borderBottom: "1px solid #DFDFDF",
              borderTop: "1px solid #DFDFDF",
              fontSize: "13px",
              textAlign: "center",
              fontWeight: "normal",
              backgroundColor: rowIdx % 2 === 0 ? "#d5e5ff" : "white",
              cursor: "pointer",
            };

            return (
              <tr
                key={row.id}
                style={rowStyle}
                onClick={() => openDetailsPopUp(row.original)} // Full row object
              >
                {row.getVisibleCells().map((cell, cellIdx) => {
                  const isFirst = cellIdx === 0;
                  const isDate = cellIdx === 2;
                  const cellStyle = {
                    borderBottom: "1px solid #DFDFDF",
                    borderTop: "1px solid #DFDFDF",
                    fontSize: "0.75vw",
                    textAlign: isFirst ? "left" : "center",
                    paddingLeft: isFirst ? "10px" : "0px",
                    width: isDate ? "50px" : "100px",
                  };
                  return (
                    <td key={cell.id} style={cellStyle}>
                      <p style={{ padding: "0", minHeight: "40px" }}>
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                      </p>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ProcessingSummaryTableForCoa;